(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('wos-personalizer')) {
  customElements.define('wos-personalizer', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const policy = document.createElement('template');
      policy.innerHTML = this.dataset.pricePolicy || '';
      const policyCopy = policy.innerHTML;
      const observe = () => this.observer.observe(this, { childList: true, subtree: true });
      const update = () => {
        this.frame = null;
        this.observer.disconnect();
        try {
          const delivery = this.querySelector('[data-wos-delivery]');
          const price = this.querySelector('.tee-product-price');
          if (delivery && price && !price.contains(delivery)) price.append(delivery);
          const rating = this.querySelector('.jdgm-preview-badge');
          const ratingHome = this.querySelector('[data-wos-product-rating]');
          if (rating && ratingHome && !ratingHome.contains(rating)) ratingHome.append(rating);
          else if (rating && !ratingHome && price && !price.contains(rating)) price.prepend(rating);
          const socialProof = this.querySelector('[data-wos-social-proof]');
          const benefits = this.querySelector('.wos-product-benefits');
          if (price && benefits && price.nextElementSibling !== benefits && !socialProof) price.after(benefits);
          if (price && socialProof && price.nextElementSibling !== socialProof) price.after(socialProof);
          if (socialProof && benefits && socialProof.nextElementSibling !== benefits) socialProof.after(benefits);
          const fitHelp = this.querySelector('[data-wos-fit-help]');
          const choices = this.querySelector('.tee-field--teeinblue-available-prod');
          if (fitHelp && choices && choices.nextElementSibling !== fitHelp) choices.after(fitHelp);
          this.querySelectorAll('.tee-product-price-custom-info').forEach(info => {
            if (policyCopy && info.innerHTML !== policyCopy) info.innerHTML = policyCopy;
          });
          this.querySelectorAll('.tee-field--text').forEach(field => {
            const heading = field.querySelector('.tee-field__heading');
            const input = field.querySelector('input[type=text]');
            if (!heading || !input) return;
            if (heading.textContent.trim() === 'Text layer' && this.dataset.nameLabel) {
              heading.textContent = this.dataset.nameLabel;
            }
            const label = heading.textContent.replace(/\*/g, '').trim();
            if (input.getAttribute('aria-label') !== label) input.setAttribute('aria-label', label);
          });
        } finally {
          if (this.isConnected) observe();
        }
      };
      this.observer = new MutationObserver(() => {
        if (this.frame == null) this.frame = requestAnimationFrame(update);
      });
      update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-bootleg-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const init = (root) => {
    if (instances.has(root)) return;
    const panels = [...root.querySelectorAll('[data-bootleg-audience]')];
    const names = panels.map(panel => panel.dataset.bootlegAudience);
    let last = '';
    let pending = false;
    const update = () => {
      pending = false;
      const form = document.querySelector('#tee-artwork-form');
      const select = form && [...form.querySelectorAll('select')].find(field => {
        const labels = [...field.options].map(option => option.textContent.trim());
        return labels.includes('PAPA') && labels.includes('MAMA') && labels.includes('BESTIE');
      });
      const title = select?.selectedOptions[0]?.textContent.trim();
      const current = names.includes(title) ? title : 'Eigener Text';
      if (last === current) return;
      panels.forEach(panel => { panel.hidden = panel.dataset.bootlegAudience !== current; });
      root.dataset.activeAudience = current;
      last = current;
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
    document.addEventListener('change', schedule);
    const observer = new MutationObserver(records => {
      if (records.some(record => !root.contains(record.target))) schedule();
    });
    const personalizer = document.querySelector('wos-personalizer');
    if (personalizer) observer.observe(personalizer, { childList: true, subtree: true });
    const onUnload = event => {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      document.removeEventListener('change', schedule);
      document.removeEventListener('shopify:section:unload', onUnload);
      instances.delete(root);
    };
    document.addEventListener('shopify:section:unload', onUnload);
    instances.set(root, observer);
    update();
  };
  const initAll = () => document.querySelectorAll('[data-bootleg-story]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-mug-animal-filter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__wosMugAnimalFilterLoaded) return;
    window.__wosMugAnimalFilterLoaded = true;

    const markerSelector = '[data-wos-mug-animal-filter]';
    const instances = new Map();

    const normalize = (value) => String(value || '')
      .normalize('NFC')
      .toLocaleLowerCase('de-DE')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    const normalizeLoose = (value) => normalize(value)
      .replace(/ae/g, 'a')
      .replace(/oe/g, 'o')
      .replace(/ue/g, 'u');

    const elementFromNode = (node) => {
      if (!node) return null;
      return node.nodeType === 1 ? node : node.parentElement;
    };

    const getFieldLabel = (field) => {
      const label = field.querySelector(
        ':scope > .tee-field__label, :scope > .tee-field__heading, :scope > .tee-label, :scope > legend, ' +
        ':scope > * > .tee-field__label, :scope > * > .tee-field__heading'
      );
      return normalize(label ? label.textContent.replace(/\*/g, '') : '');
    };

    const getItems = (field) => Array.from(field.querySelectorAll('.tee-clipart-col'))
      .filter((item) => item.querySelector('.tee-clipart input[type="radio"]'));

    const getItemName = (item) => {
      const text = item.querySelector('.tee-clipart-label__text');
      if (text && text.textContent.trim()) return text.textContent.trim();

      const image = item.querySelector('.tee-clipart-thumbnail[alt], img[alt]');
      if (image && image.getAttribute('alt')) return image.getAttribute('alt').trim();

      const label = item.querySelector('label');
      return label ? label.textContent.trim() : '';
    };

    const restoreItems = (field) => {
      if (!field) return;
      field.querySelectorAll('[data-wos-animal-hidden="true"]').forEach((item) => {
        item.removeAttribute('data-wos-animal-hidden');
        item.removeAttribute('hidden');
      });
    };

    const findField = (state) => {
      const candidates = Array.from(state.mainProduct.querySelectorAll(
        '#tee-artwork-form .tee-field--clipart'
      ));

      if (!candidates.length) return null;

      const target = normalize(state.marker.dataset.targetFieldLabel);
      if (target) {
        const exact = candidates.find((field) => getFieldLabel(field) === target);
        if (exact) return exact;
      }

      return candidates.length === 1 ? candidates[0] : null;
    };

    const createSvg = () => {
      const namespace = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(namespace, 'svg');
      const circle = document.createElementNS(namespace, 'circle');
      const path = document.createElementNS(namespace, 'path');

      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('aria-hidden', 'true');
      circle.setAttribute('cx', '11');
      circle.setAttribute('cy', '11');
      circle.setAttribute('r', '7');
      circle.setAttribute('stroke', 'currentColor');
      circle.setAttribute('stroke-width', '1.8');
      path.setAttribute('d', 'm16.2 16.2 4 4');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.8');
      path.setAttribute('stroke-linecap', 'round');
      svg.append(circle, path);
      return svg;
    };

    const applyStyles = (state, ui) => {
      const values = {
        '--wos-animal-bg': state.marker.dataset.backgroundColor,
        '--wos-animal-input-bg': state.marker.dataset.inputBackgroundColor,
        '--wos-animal-text': state.marker.dataset.textColor,
        '--wos-animal-muted': state.marker.dataset.mutedColor,
        '--wos-animal-border': state.marker.dataset.borderColor,
        '--wos-animal-focus': state.marker.dataset.focusColor,
        '--wos-animal-radius': state.marker.dataset.radius
      };

      Object.entries(values).forEach(([property, value]) => {
        if (value) ui.style.setProperty(property, value);
      });
    };

    const buildUi = (state) => {
      const ui = document.createElement('div');
      const label = document.createElement('label');
      const control = document.createElement('div');
      const icon = document.createElement('span');
      const input = document.createElement('input');
      const clear = document.createElement('button');
      const status = document.createElement('p');
      const empty = document.createElement('div');
      const emptyTitle = document.createElement('p');
      const emptyCopy = document.createElement('p');
      const ownerId = state.marker.dataset.ownerId;

      ui.className = 'wos-animal-finder';
      ui.dataset.wosAnimalFinder = ownerId;
      label.className = 'wos-animal-finder__label';
      label.htmlFor = `WosAnimalSearch-${ownerId}`;
      label.textContent = state.marker.dataset.heading;
      control.className = 'wos-animal-finder__control';
      icon.className = 'wos-animal-finder__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.append(createSvg());

      input.id = `WosAnimalSearch-${ownerId}`;
      input.className = 'wos-animal-finder__input';
      input.type = 'search';
      input.placeholder = state.marker.dataset.placeholder;
      input.autocomplete = 'off';
      input.spellcheck = false;
      input.setAttribute('enterkeyhint', 'search');
      input.setAttribute('inputmode', 'search');
      input.value = state.term;
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') event.preventDefault();
        if (event.key === 'Escape') { input.value = ''; state.term = ''; applyFilter(state); }
      });

      clear.className = 'wos-animal-finder__clear';
      clear.type = 'button';
      clear.setAttribute('aria-label', state.marker.dataset.clearLabel);
      clear.textContent = '×';
      clear.hidden = !state.term.trim();

      status.className = 'wos-animal-finder__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');

      empty.className = 'wos-animal-finder__empty';
      empty.hidden = true;
      emptyTitle.className = 'wos-animal-finder__empty-title';
      emptyTitle.textContent = state.marker.dataset.noResultsHeading;
      emptyCopy.className = 'wos-animal-finder__empty-copy';
      emptyCopy.textContent = state.marker.dataset.noResultsCopy;
      empty.append(emptyTitle, emptyCopy);

      if (
        state.marker.dataset.showRequestLink === 'true' &&
        state.marker.dataset.requestUrl &&
        state.marker.dataset.requestLabel
      ) {
        const requestLink = document.createElement('a');
        requestLink.className = 'wos-animal-finder__request';
        requestLink.href = state.marker.dataset.requestUrl;
        requestLink.textContent = state.marker.dataset.requestLabel;
        empty.append(requestLink);
      }

      control.append(icon, input, clear);
      ui.append(label, control, status, empty);
      applyStyles(state, ui);

      state.uiAbort = new AbortController();
      input.addEventListener('input', () => {
        state.term = input.value;
        const row = state.field.querySelector('.tee-clipart-row');
        if (row) row.scrollTop = 0;
        scheduleFilter(state);
      }, { signal: state.uiAbort.signal });
      input.addEventListener('search', () => {
        state.term = input.value;
        const row = state.field.querySelector('.tee-clipart-row');
        if (row) row.scrollTop = 0;
        scheduleFilter(state);
      }, { signal: state.uiAbort.signal });
      clear.addEventListener('click', () => {
        input.value = '';
        state.term = '';
        applyFilter(state);
        input.focus();
      }, { signal: state.uiAbort.signal });

      state.ui = ui;
      state.input = input;
      state.clear = clear;
      state.status = status;
      state.empty = empty;
      return ui;
    };

    const formatStatus = (state, visible, total, hasQuery) => {
      if (!hasQuery) return `${total} ${state.marker.dataset.statusAll}`;
      const label = visible === 1
        ? state.marker.dataset.statusSingular
        : state.marker.dataset.statusPlural;
      return `${visible} ${label}`;
    };

    const applyFilter = (state) => {
      state.filterFrame = null;
      if (!state.field || !state.field.isConnected || !state.ui || !state.ui.isConnected) return;

      try {
        const items = getItems(state.field);
        const trimmedTerm = state.term.trim();
        const query = normalize(trimmedTerm);
        const looseQuery = normalizeLoose(trimmedTerm);
        let visible = 0;

        items.forEach((item) => {
          const name = getItemName(item);
          const key = normalize(name);
          const looseKey = normalizeLoose(name);
          const matches = !query || key.includes(query) || looseKey.includes(looseQuery);

          if (matches) {
            item.removeAttribute('data-wos-animal-hidden');
            item.removeAttribute('hidden');
            visible += 1;
          } else {
            item.dataset.wosAnimalHidden = 'true';
            item.hidden = true;
          }
        });

        state.clear.hidden = !trimmedTerm;
        state.empty.hidden = !trimmedTerm || visible > 0;
        const statusText = formatStatus(state, visible, items.length, Boolean(trimmedTerm));
        if (state.status.textContent !== statusText) state.status.textContent = statusText;
      } catch (error) {
        restoreItems(state.field);
        if (state.ui) state.ui.remove();
        state.ui = null;
      }
    };

    const scheduleFilter = (state) => {
      if (state.filterFrame) return;
      state.filterFrame = window.requestAnimationFrame(() => applyFilter(state));
    };

    const detachUi = (state) => {
      if (state.filterFrame) window.cancelAnimationFrame(state.filterFrame);
      state.filterFrame = null;
      if (state.uiAbort) state.uiAbort.abort();
      restoreItems(state.field);
      if (state.ui) state.ui.remove();
      state.uiAbort = null;
      state.ui = null;
      state.input = null;
      state.clear = null;
      state.status = null;
      state.empty = null;
      state.field = null;
    };

    const mount = (state, field) => {
      const row = field.querySelector('.tee-clipart-row');
      if (!row || !getItems(field).length) return false;

      const existing = field.querySelector('.wos-animal-finder');
      if (existing) existing.remove();

      state.field = field;
      const ui = buildUi(state);
      row.insertAdjacentElement('beforebegin', ui);
      applyFilter(state);
      return true;
    };

    const reconcile = (state) => {
      state.reconcileFrame = null;
      if (!state.marker.isConnected || !state.mainProduct.isConnected) return;

      const field = findField(state);
      if (!field) {
        if (state.field && !state.field.isConnected) detachUi(state);
        return;
      }

      if (state.field !== field || !state.ui || !state.ui.isConnected) {
        detachUi(state);
        mount(state, field);
        return;
      }

      scheduleFilter(state);
    };

    const scheduleReconcile = (state) => {
      if (state.reconcileFrame) return;
      state.reconcileFrame = window.requestAnimationFrame(() => reconcile(state));
    };

    const mutationIsRelevant = (mutation) => {
      const target = elementFromNode(mutation.target);
      if (target && target.closest('.wos-animal-finder')) return false;
      if (target && target.closest('#teeFormInputs .tee-field--clipart')) return true;

      return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some((node) => {
        const element = elementFromNode(node);
        if (!element) return false;
        return element.matches?.('.tee-field--clipart, .tee-clipart-row, .tee-clipart-col') ||
          element.querySelector?.('.tee-field--clipart, .tee-clipart-row, .tee-clipart-col');
      });
    };

    const init = (marker) => {
      if (!marker || instances.has(marker)) return;

      const mainProduct = document.querySelector('#MainContent [data-section-type="product"]');
      if (!mainProduct) return;

      const state = {
        marker,
        mainProduct,
        field: null,
        ui: null,
        input: null,
        clear: null,
        status: null,
        empty: null,
        term: '',
        filterFrame: null,
        reconcileFrame: null,
        uiAbort: null,
        lifecycleAbort: new AbortController(),
        observer: null
      };

      const schedule = () => scheduleReconcile(state);
      document.addEventListener('wos:animal-search-reset', () => {
        state.term = '';
        if (state.input) state.input.value = '';
        applyFilter(state);
      }, { signal: state.lifecycleAbort.signal });
      document.addEventListener('teeinblue-event-component-injected', schedule, {
        signal: state.lifecycleAbort.signal
      });
      window.addEventListener('pageshow', schedule, { signal: state.lifecycleAbort.signal });
      window.addEventListener('popstate', schedule, { signal: state.lifecycleAbort.signal });

      state.observer = new MutationObserver((mutations) => {
        if (mutations.some(mutationIsRelevant)) scheduleReconcile(state);
      });
      state.observer.observe(mainProduct, { childList: true, subtree: true });

      instances.set(marker, state);
      scheduleReconcile(state);
    };

    const destroy = (marker) => {
      const state = instances.get(marker);
      if (!state) return;

      if (state.observer) state.observer.disconnect();
      if (state.lifecycleAbort) state.lifecycleAbort.abort();
      if (state.reconcileFrame) window.cancelAnimationFrame(state.reconcileFrame);
      detachUi(state);
      instances.delete(marker);
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches(markerSelector)) init(scope);
      scope.querySelectorAll(markerSelector).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const marker = event.target.matches?.(markerSelector)
        ? event.target
        : event.target.querySelector?.(markerSelector);
      if (marker) destroy(marker);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-spruchsuche"] && !Shopify.designMode) return;
  try {
    
  const wosTitleQuery=value=>(value.replace(/title:/g,'').replace(/\*/g,'').replace(/\bAND\b/g,' ').match(/[\p{L}\p{N}]+/gu)||[]).map(word=>'title:'+word+'*').join(' AND ');
  document.addEventListener('submit',event=>{const form=event.target;if(!(form instanceof HTMLFormElement)||!form.matches('form[role=search]'))return;const input=form.querySelector('[name=q]');if(!input)return;event.preventDefault();const url=new URL(form.action,location.origin);url.searchParams.set('q',wosTitleQuery(input.value));url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');location.assign(url.href)},true);

  if(!customElements.get('wos-search'))customElements.define('wos-search',class extends HTMLElement{
    connectedCallback(){if(this.initialized)return;this.initialized=true;this.input=this.querySelector('[data-input]');this.results=this.querySelector('[data-results]');this.status=this.querySelector('[data-status]');this.form=this.querySelector('form');this.index=-1;this.listen=new AbortController();const opts={signal:this.listen.signal};this.input.addEventListener('input',()=>{clearTimeout(this.timer);this.controller?.abort();this.close();if(this.input.value.trim().length<2)return;this.timer=setTimeout(()=>this.find(),220)},opts);this.input.addEventListener('keydown',e=>this.keys(e),opts);document.addEventListener('pointerdown',e=>{if(!this.contains(e.target))this.close()},opts);this.addEventListener('focusout',()=>setTimeout(()=>{if(!this.contains(document.activeElement))this.close()},0),opts)}
    disconnectedCallback(){this.listen?.abort();this.controller?.abort();clearTimeout(this.timer);this.initialized=false}
    close(){this.results.hidden=true;this.input.setAttribute('aria-expanded','false');this.input.removeAttribute('aria-activedescendant');this.index=-1}
    async find(){const query=this.input.value.trim();this.controller=new AbortController();this.status.textContent=this.dataset.loading;try{const params=new URLSearchParams({q:wosTitleQuery(query),'resources[type]':'product','resources[limit]':'6','resources[options][unavailable_products]':'last','resources[options][fields]':'title'});const response=await fetch(this.dataset.endpoint+'.json?'+params,{signal:this.controller.signal});if(!response.ok)throw new Error('Search unavailable');const data=await response.json();if(query!==this.input.value.trim())return;const products=data.resources?.results?.products||[];this.results.replaceChildren();products.forEach((p,i)=>{const a=document.createElement('a');a.href=p.url;a.className='wos-search__result';a.id=this.results.id+'-'+i;a.setAttribute('role','option');a.setAttribute('aria-selected','false');const src=p.featured_image?.url||p.image;if(src){const image=document.createElement('img');image.src=src;image.alt='';image.loading='lazy';image.width=58;image.height=66;a.append(image)}const label=document.createElement('span');label.textContent=p.title;const price=document.createElement('small');if(p.price!==undefined)price.textContent=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency||'EUR'}).format(Number(p.price));label.append(price);a.append(label);this.results.append(a)});const all=document.createElement('a');all.className='wos-search__all';all.href=this.form.action+'?type=product&q='+encodeURIComponent(wosTitleQuery(query));all.textContent=(products.length?this.dataset.all:this.dataset.empty)+' →';all.setAttribute('role','option');all.id=this.results.id+'-all';this.results.append(all);this.results.hidden=false;this.input.setAttribute('aria-expanded','true');this.status.textContent=products.length?products.length+' '+this.dataset.all:this.dataset.empty}catch(error){if(error.name!=='AbortError'){this.close();this.status.textContent=''}}}
    keys(event){if(event.key==='Escape'){this.close();return}if(this.results.hidden)return;const options=[...this.results.querySelectorAll('[role=option]')];if(event.key==='ArrowDown'||event.key==='ArrowUp'){event.preventDefault();this.index=(this.index+(event.key==='ArrowDown'?1:-1)+options.length)%options.length;options.forEach((el,i)=>el.setAttribute('aria-selected',String(i===this.index)));this.input.setAttribute('aria-activedescendant',options[this.index].id);options[this.index].scrollIntoView({block:'nearest'})}else if(event.key==='Enter'&&this.index>=0){event.preventDefault();options[this.index].click()}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-tier-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  const animals=[
    {name:'Faultier',motif:'Faultier',title:'Team Faultier',text:'Du musst nicht überall als Erstes ankommen. Lieber einen Gang runterschalten und die Kaffeepause in aller Ruhe genießen.',quote:'„Ich bin nicht langsam. Ich bin im Pausenmodus.“'},
    {name:'Panda',motif:'Panda',title:'Team Panda',text:'Deine Antwort auf einen wilden Tag: etwas Warmes in der Hand und ein gemütlicher Moment. Kleine Genussmomente sind genau dein Ding.',quote:'„Erst gemütlich. Dann sehen wir weiter.“'},
    {name:'Igel',motif:'Igel',title:'Team Igel',text:'Du bist gern für andere da. Aber manchmal ist deine Lieblingsgesellschaft einfach eine Tasse und ein bisschen Ruhe. Völlig verständlich.',quote:'„Heute nur für Heißgetränke erreichbar.“'},
    {name:'Katze',motif:'Katze 1',title:'Team Katze',text:'Du hast deinen eigenen Kopf. Und dein eigenes Tempo. Deine Pause braucht keine Erlaubnis – höchstens noch einen guten Kaffee.',quote:'„Ich mach das. Aber auf meine Art.“'}
  ];
  const questions=[
    {title:'Der Tag wird wild. Was denkst du zuerst?',answers:['Immer mit der Ruhe. Ich bin nicht auf der Flucht.','Erst mal einen Kaffee. Und vielleicht einen Keks.','Ich brauche kurz meine Ruhe. Von allen.','Ich entscheide selbst, was jetzt wichtig ist.']},
    {title:'Deine perfekte Pause sieht so aus …',answers:['Füße hoch. Der Rest kann kurz warten.','Lieblingsgetränk, Lieblingsplatz, alles gut.','Handy stumm. Tür zu. Herrlich.','Spontan. Je nachdem, worauf ich Lust habe.']},
    {title:'Welcher Satz könnte von dir sein?',answers:['„Morgen ist auch noch ein Tag.“','„Mit einer kleinen Pause wird alles gemütlicher.“','„Nicht persönlich nehmen. Ich brauche Abstand.“','„Ich muss gar nichts. Außer vielleicht Kaffee.“']}
  ];
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const stage=root.querySelector('[data-quiz-stage]'),status=root.querySelector('[data-quiz-status]');
    let answers=[],step=0,winner=0;
    const images=Array.from(root.querySelectorAll('.wos-quiz__portraits img')).map(i=>i.src);
    const moveFocus=()=>{const heading=stage.querySelector('h3');if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});}};
    function question(){
      status.textContent='';
      const q=questions[step];
      stage.innerHTML=`<div class="wos-quiz__topline"><span>DEIN PAUSENTYP</span><span>0${step+1} / 03</span></div><div class="wos-quiz__progress" aria-hidden="true">${questions.map((_,i)=>`<i class="${i<=step?'is-done':''}"></i>`).join('')}</div><h3>${q.title}</h3><div class="wos-quiz__answers">${q.answers.map((a,i)=>`<button type="button" class="wos-quiz__answer" data-answer="${i}" aria-pressed="${answers[step]===i}"><span class="wos-quiz__letter" aria-hidden="true">${'ABCD'[i]}</span><span>${a}</span></button>`).join('')}</div>${step>0?'<button type="button" class="wos-quiz__back" data-back>← Eine Frage zurück</button>':''}`;
      moveFocus();
    }
    function result(){
      const scores=animals.map((_,i)=>answers.filter(a=>a===i).length),max=Math.max(...scores);
      winner=[...answers].reverse().find(a=>scores[a]===max);
      const a=animals[winner];
      stage.innerHTML=`<div class="wos-quiz__result-head"><img src="${images[winner]}" width="95" height="95" alt="${a.name}"><div><span class="wos-quiz__eyebrow">DEIN TIERISCHER PAUSENBEGLEITER</span><h3>${a.title}</h3></div></div><p>${a.text}</p><p class="wos-quiz__quote">${a.quote}</p><button type="button" class="wos-quiz__primary" data-choose>${a.name}-Motiv auswählen <span aria-hidden="true">↗</span></button><p class="wos-quiz__note">Dein Motiv auf der Tasse. Deinen Namen ergänzt du oben.</p><button type="button" class="wos-quiz__back" data-restart>Noch mal spielen</button>`;
      moveFocus();
    }
    root.querySelector('[data-quiz-start]').hidden=false;
    root.addEventListener('click',e=>{
      const button=e.target.closest('button');if(!button)return;
      if(button.hasAttribute('data-quiz-start')||button.hasAttribute('data-restart')){answers=[];step=0;question();}
      if(button.hasAttribute('data-answer')){answers[step]=Number(button.dataset.answer);if(step<2){step++;question();}else result();}
      if(button.hasAttribute('data-back')){step--;question();}
      if(button.hasAttribute('data-choose')){
        document.dispatchEvent(new CustomEvent('wos:animal-search-reset'));
        const target=Array.from(document.querySelectorAll('#tee-artwork-form img.tee-clipart-thumbnail')).find(i=>i.alt===animals[winner].motif);
        const label=target&&target.closest('label[for]');
        const input=label&&document.getElementById(label.htmlFor);
        if(input&&!input.disabled){
          label.click();
          const name=document.querySelector('#teeFormInputs input[type="text"]');
          const destination=name||label;
          destination.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
          if(name)name.focus({preventScroll:true});
          status.textContent=animals[winner].name+' ist ausgewählt. Ergänze jetzt deinen Namen.';
        }else{
          status.textContent='Wähle oben in der Motivauswahl „'+animals[winner].motif+'“. Die Auswahl lädt möglicherweise noch.';
        }
      }
    });
    function addEntry(){
      const field=document.getElementById('tee-field--layer-374523');
      if(!field||document.querySelector('[data-quiz-entry]'))return !!field;
      const link=document.createElement('button');link.type='button';link.className='wos-quiz-link';link.dataset.quizEntry='';link.textContent='Noch unsicher? Finde dein Tier in 30 Sekunden ↗';
      link.addEventListener('click',()=>{root.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});const b=stage.querySelector('button');if(b)b.focus({preventScroll:true});});
      field.prepend(link);return true;
    }
    if(!addEntry()){
      const observer=new MutationObserver(()=>{if(addEntry())observer.disconnect();});observer.observe(document.body,{childList:true,subtree:true});setTimeout(()=>observer.disconnect(),20000);
    }
  }
  document.querySelectorAll('[data-wos-quiz]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-wos-quiz]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-ugly-product-main"]) return;
  try {
    
if (!customElements.get('wos-personalizer')) {
  customElements.define('wos-personalizer', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const policy = document.createElement('template');
      policy.innerHTML = this.dataset.pricePolicy || '';
      const policyCopy = policy.innerHTML;
      const observe = () => this.observer.observe(this, { childList: true, subtree: true });
      const update = () => {
        this.frame = null;
        this.observer.disconnect();
        try {
          const delivery = this.querySelector('[data-wos-delivery]');
          const price = this.querySelector('.tee-product-price');
          if (delivery && price && !price.contains(delivery)) price.append(delivery);
          const rating = this.querySelector('.jdgm-preview-badge');
          const ratingHome = this.querySelector('[data-wos-product-rating]');
          if (rating && ratingHome && !ratingHome.contains(rating)) ratingHome.append(rating);
          else if (rating && !ratingHome && price && !price.contains(rating)) price.prepend(rating);
          const socialProof = this.querySelector('[data-wos-social-proof]');
          const benefits = this.querySelector('.wos-product-benefits');
          if (price && benefits && price.nextElementSibling !== benefits && !socialProof) price.after(benefits);
          if (price && socialProof && price.nextElementSibling !== socialProof) price.after(socialProof);
          if (socialProof && benefits && socialProof.nextElementSibling !== benefits) socialProof.after(benefits);
          const fitHelp = this.querySelector('[data-wos-fit-help]');
          const choices = this.querySelector('.tee-field--teeinblue-available-prod');
          if (fitHelp && choices && choices.nextElementSibling !== fitHelp) choices.after(fitHelp);
          this.querySelectorAll('.tee-product-price-custom-info').forEach(info => {
            if (policyCopy && info.innerHTML !== policyCopy) info.innerHTML = policyCopy;
          });
          this.querySelectorAll('.tee-field--text').forEach(field => {
            const heading = field.querySelector('.tee-field__heading');
            const input = field.querySelector('input[type=text]');
            if (!heading || !input) return;
            if (heading.textContent.trim() === 'Text layer' && this.dataset.nameLabel) {
              heading.textContent = this.dataset.nameLabel;
            }
            const label = heading.textContent.replace(/\*/g, '').trim();
            if (input.getAttribute('aria-label') !== label) input.setAttribute('aria-label', label);
          });
        } finally {
          if (this.isConnected) observe();
        }
      };
      this.observer = new MutationObserver(() => {
        if (this.frame == null) this.frame = requestAnimationFrame(update);
      });
      update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
